var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.479 13.842h4.92c.896 0 1.6-.713 1.6-1.566v-6.71c0-.853-.704-1.566-1.6-1.566h-10.8c-.896 0-1.6.713-1.6 1.566v6.71c0 .853.704 1.566 1.6 1.566h1.6V17h.003l.002-.001 4.276-3.157zm-3.68 3.961a1.01 1.01 0 0 1-1.4-.199.98.98 0 0 1-.199-.59v-2.172h-.6c-1.436 0-2.6-1.149-2.6-2.566v-6.71C1.999 4.149 3.163 3 4.599 3h10.8c1.436 0 2.6 1.149 2.6 2.566v6.71c0 1.418-1.164 2.566-2.6 2.566h-4.59l-4.011 2.961z"
  })));
};
export default SvgComment;